<template>
    <div>
        <p> Frb Web Version: {{this.version}}</p>
    </div>
</template>

<script>
export default {
  data () {
    return {
      version: process.env.VUE_APP_VERSION
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue